const initScrollingAnimations = () => {
	if (window.innerWidth < 767) {
		$('.js-fade-from-bottom, .js-fade-to-colour, .js-fade-in').addClass('is-in-view');
	} else {
		if (!!window.IntersectionObserver) {
			let scrollPos = 0,
				scrollDir = false,
				oldScrollPos = 0;

			$(window).on('scroll', function () {
				oldScrollPos = scrollPos;
				scrollPos = $(window).scrollTop();

				scrollDir = scrollPos > oldScrollPos ? 'down' : 'up';
			});

			function callback(entries, observer) {
				entries.forEach((entry) => {
					const el = entry.target;
					if (entry.isIntersecting) {
						// General fade in
						if (
							el.classList.contains('js-fade-in') ||
							el.classList.contains('js-fade-from-bottom') ||
							el.classList.contains('js-fade-to-colour')
						) {
							el.classList.add('is-in-view');
						}
					}
				});
			}

			const observerBottomMargin = window.innerHeight < 700 ? '-20px' : '-100px';
			const observer = new IntersectionObserver(callback, {
				root: null,
				rootMargin: `0px 0px ${observerBottomMargin} 0px`,
				threshold: 0,
			});

			// General fade ins
			if (document.querySelectorAll('.js-fade-from-bottom').length) {
				document
					.querySelectorAll('.js-fade-from-bottom')
					.forEach((el) => observer.observe(el));
			}
			if (document.querySelectorAll('.js-fade-to-colour').length) {
				document
					.querySelectorAll('.js-fade-to-colour')
					.forEach((el) => observer.observe(el));
			}
			if (document.querySelectorAll('.js-fade-in').length) {
				document.querySelectorAll('.js-fade-in').forEach((el) => observer.observe(el));
			}
		} else {
			$('.js-fade-from-bottom, .js-fade-to-colour, .js-fade-in, .js-img-zoom-out').addClass('is-in-view');
		}
	}
};
